export const BETTER_AUTH_BASE_PATH = "/auth/better" as const;
export const BETTER_AUTH_MFA_EMAIL_HEADER = "x-rivetai-mfa-email" as const;

export function isBetterAuthEnabled(raw: string | boolean | undefined): boolean {
  return raw === true || raw === "true";
}
